import React, { useEffect, useState, useContext  } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Typography, TextField, MenuItem, Button, Alert, Stack,Tooltip } from '@mui/material';
import pagamentoApi from '../../api/pagamentoApi';
import { AuthContext } from '../../auth/AuthContext';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import ProtectedAction from '../../components/ProtectedAction';
import { loadStripe } from '@stripe/stripe-js';

export default function PagamentoEditPage() {
  const { id } = useParams(); // id del pagamento
    const { user } = useContext(AuthContext);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadMsg, setUploadMsg] = useState('');
  const [pdfPath, setPdfPath] = useState(null);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    stato: 'CREATO',
    metodo: 'CARTA',
    importo: '',
    riferimentoEsterno: '',
    dataPagamento: '',
    pdfPath:'',
  });
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contrattoId, setContrattoId] = useState(null);

  const stati = ['CREATO', 'IN_ATTESA', 'IN_PROCESSO','PAGATO', 'VERIFICATO','FALLITO'];
  const metodi = ['CARTA', 'BONIFICO', 'PAYPAL'];

  useEffect(() => {
    const load = async () => {
      try {
        const res = await pagamentoApi.get(id);
        setForm({
          stato: res.data.stato,
          metodo: res.data.metodo,
          importo: res.data.importo,
          riferimentoEsterno: res.data.riferimentoEsterno || '',
          dataPagamento: res.data.dataPagamento || '',
          pdfPath: res.data.pdfPath || ''
        });
        setPdfPath(res.data.pdfPath || null);
        setContrattoId(res.data.contrattoId);
      } catch (e) {
        setErr(e.response?.data || e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) return <div>Caricamento...</div>;

  const submit = async (e) => {
    e.preventDefault();
    try {
      await pagamentoApi.update(id, form);
      navigate(`/contratti/${contrattoId}/edit`);
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

    const isAdmin = (user,contractState) => {
            console.log("isAdmin",user.role);
            console.log("isAdmin",contractState && contractState!==''?contractState:'ACTIVE');
            return user?.role==='ADMIN';
    };


  return (
    <Container maxWidth="sm">

    <BackButtonDesktop />
    {form.stato === 'IN_ATTESA' &&
    <Alert severity="info" sx={{ mb: 2 }}>
    <Typography sx={{ mb: 2 }}>Si può effettuare il pagamento in due modalità:</Typography>
    <Typography sx={{ mb: 2 }}>- bonifico bancario. Effettuare un bonifico verso IBAN: IT56 H034 4003 2140 0000 0921 100, intestato a CO.S.F.IMP. S.R.L.S., causale "saldo abbonamento",
    e allegare la ricevuta di pagamento in questa pagina. L'amministrazione verificherà l'effettiva esecuzione
      del pagamento ed attiverà il contratto.</Typography>
    {user.stripeenabled && '- pagamento con carta (Stripe). cliccare sul bottone PAGA CON CARTA (icona carta di credito nelle azioni del pagamento). Si viene indirizzati alla pagina Stripe per il pagamento con carta. Al termine della transazione si viene mandati su una pagina di conferma di pagamento e il contratto sarà attivato.'}</Alert>
    }

      <Typography variant="h5" sx={{ mb: 2 }}>
        Modifica Pagamento
      </Typography>
        <TextField
          type="file"
          fullWidth
          inputProps={{ accept: ".pdf" }}
          onChange={e => setFile(e.target.files[0])}
          sx={{ my: 1 }}
        />
        <Button
          variant="outlined"
          disabled={!file || uploading || scadenza.stato!='IN_ATTESA'}
          onClick={async () => {
            if (!file) return;
            setUploading(true);
            setUploadMsg('');
            try {
              const formData = new FormData();
              formData.append("file", file);
              const res = await pagamentoApi.uploadFile(id, formData);
              setUploadMsg("File caricato: " + res.data.fileName);
              setFile(null); // reset input
              const respag = await pagamentoApi.get(id);
              setForm({
                stato: respag.data.stato,
                metodo: respag.data.metodo,
                importo: respag.data.importo,
                riferimentoEsterno: respag.data.riferimentoEsterno || '',
                dataPagamento: respag.data.dataPagamento || ''
              });
              setPdfPath(respag.data.pdfPath || null);
              setContrattoId(respag.data.contrattoId);
            } catch (err) {
              setUploadMsg("Errore upload: " + (err.response?.data || err.message));
            } finally {
              setUploading(false);
            }
          }}
          sx={{ my: 1 }}
        >
          {uploading ? "Caricamento..." : "Carica PDF ricevuta"}
        </Button>
        {uploadMsg && <Alert severity="info">{uploadMsg}</Alert>}
        {/* Bottone Stripe Checkout */}
        {user.stripeenabled && form.stato==='IN_ATTESA' &&
        <Button
          variant="contained"
          color="primary"
          sx={{ my: 1 }}
          onClick={async () => {
            try {
              const res = await pagamentoApi.payWithCard(id);
              if (res.data.checkoutUrl) {
                window.location.href = res.data.checkoutUrl; // reindirizza a Stripe Checkout
              }
            } catch (e) {
              setErr("Errore pagamento con carta: " + (e.response?.data || e.message));
            }
          }}
        >
          Paga con carta
        </Button>}
      {err && <Alert severity="error" sx={{ mb: 2 }}>{String(err)}</Alert>}
    {pdfPath && (
      <Button
        variant="outlined"
        color="success"
        sx={{ my: 1 }}
        onClick={async () => {
          try {
            const res = await pagamentoApi.downloadFile(id);

            const url = window.URL.createObjectURL(
              new Blob([res.data], { type: 'application/pdf' })
            );

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', pdfPath);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } catch (e) {
            setErr("Errore download file");
          }
        }}
      >
        Scarica ricevuta PDF
      </Button>
    )}
      <form onSubmit={submit}>
        <TextField
          select
          fullWidth
          label="Stato"
          value={form.stato}
          onChange={e => setForm({ ...form, stato: e.target.value })}
          sx={{ my: 1 }}
          required
        >
          {stati.map(s => (
            <MenuItem key={s} value={s}>{s}</MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          label="Metodo"
          value={form.metodo}
          onChange={e => setForm({ ...form, metodo: e.target.value })}
          sx={{ my: 1 }}
          required
        >
          {metodi.map(m => (
            <MenuItem key={m} value={m}>{m}</MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          type="number"
          label="Importo"
          value={form.importo}
          onChange={e => setForm({ ...form, importo: e.target.value })}
          sx={{ my: 1 }}
          required
        />

        <TextField
          fullWidth
          label="Riferimento Esterno"
          value={form.riferimentoEsterno}
          onChange={e => setForm({ ...form, riferimentoEsterno: e.target.value })}
          sx={{ my: 1 }}
        />

        <TextField
          fullWidth
          type="date"
          label="Data Pagamento"
          InputLabelProps={{ shrink: true }}
          value={form.dataPagamento}
          onChange={e => setForm({ ...form, dataPagamento: e.target.value })}
          sx={{ my: 1 }}
        />

        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <ProtectedAction user={user} condition={isAdmin}>
              <Button type="submit" variant="contained">Salva</Button>
            </ProtectedAction>
          <Button variant="text" onClick={() => navigate(`/contratti/${contrattoId}/edit`)}>Indietro</Button>
        </Stack>
      </form>
    </Container>
  );
}